// removed by extract-text-webpack-plugin
module.exports = {"main":"_1v3Y4IlZc6wx0S2p3DZwAY","extra":"_1446c39sfBNLvpSXEngXQa"};


//////////////////
// WEBPACK FOOTER
// ./components/ReceiptInfo.module.css
// module id = 2367
// module chunks = 1